import { ShieldOff } from 'lucide-react'

import { EmptyState } from '@/components/ui'

/** A signed-in staff member whose roles grant none of the POS pages. */
export const NoAccessPage = () => (
  <div className="grid h-full place-items-center">
    <EmptyState icon={ShieldOff} title="Nothing to open here">
      Your role has no POS permissions. Ask an admin to add them, then lock the POS and sign in again.
    </EmptyState>
  </div>
)
